// extracted by mini-css-extract-plugin
export default {"root":"CloseSharing__root--2_cg2","root_not_owner":"CloseSharing__root_not_owner--3ADHV"};